import React from 'react';
import styled from 'styled-components';
import useScript from '_utils/hooks/useScript';
import { withEditMode, withEditModeNotice } from '_containers/BaseComponent';
import { compose } from 'ramda';
import { Wrap } from './StyledEmbedlyCard';
import PropTypes from 'prop-types';

type EmbedlyCardProps = {
  rendering: any;
  editMode: boolean;
};

const EditorNotice = compose(withEditModeNotice)(styled.div``);

const Embedly = ({ editMode, fields, apiKey }) => {
  useScript('https://cdn.embedly.com/widgets/platform.js');

  //TODO - type check this
  const title = fields?.title?.value;
  const customImageUrl = fields?.customImageUrl?.value;
  const socialSharing = fields?.socialSharing?.value === 'Yes' ? '1' : '0'; //TODO get a number from SC
  const description = fields?.description?.value ? fields.description.value : '';
  const href = fields?.embedlyUrl.jss?.value ? fields?.embedlyUrl.jss.value : '';

  if (!href && !editMode) {
    return null;
  }

  return (
    <>
      <blockquote
        className="embedly-card"
        data-card-key={apiKey}
        data-card-chrome="0"
        data-card-recommend="0"
        data-card-controls={socialSharing}
        data-card-image={customImageUrl}
      >
        {!href && (
          <>
            <EditorNotice
              noticeEnabled={true}
              noticeMessage={'No url configured for Embedly Card'}
            />
          </>
        )}
        {href && (
          <h4>
            <a href={href}>{title}</a>
          </h4>
        )}
        {description && <p>{description}</p>}
      </blockquote>
    </>
  );
};

Embedly.propTypes = {
  editMode: PropTypes.bool.isRequired,
  fields: PropTypes.shape({
    title: PropTypes.shape({
      value: PropTypes.string,
    }),
    customImageUrl: PropTypes.shape({
      value: PropTypes.string,
    }),
    socialSharing: PropTypes.shape({
      value: PropTypes.string,
    }),
    description: PropTypes.shape({
      value: PropTypes.string,
    }),
    embedlyUrl: PropTypes.shape({
      jss: PropTypes.shape({
        value: PropTypes.string,
      }),
    }),
  }).isRequired,
  apiKey: PropTypes.string.isRequired,
};

const EmbedlyCard: React.FC<EmbedlyCardProps> = ({ rendering, editMode }) => {
  const fields = rendering?.fields?.data?.dataSource;
  const embedlyCardsApiKey = rendering?.fields?.data?.apiKey?.embedlyCardsApiKey?.value;

  if (!embedlyCardsApiKey && !editMode) {
    return null;
  }

  if (!fields && !editMode) {
    return null;
  }

  return (
    <Wrap>
      <Embedly fields={fields} editMode={editMode} apiKey={embedlyCardsApiKey}></Embedly>
    </Wrap>
  );
};

EmbedlyCard.propTypes = {
  rendering: PropTypes.shape({
    fields: PropTypes.shape({
      data: PropTypes.shape({
        dataSource: PropTypes.object,
        apiKey: PropTypes.shape({
          embedlyCardsApiKey: PropTypes.shape({
            value: PropTypes.string,
          }),
        }),
      }),
    }),
  }).isRequired,
  editMode: PropTypes.bool.isRequired,
};

export default compose(withEditMode, withEditModeNotice)(EmbedlyCard);
